import { render } from "./ViewPatientReports.vue?vue&type=template&id=78520b3e&scoped=true"
import script from "./ViewPatientReports.vue?vue&type=script&lang=js"
export * from "./ViewPatientReports.vue?vue&type=script&lang=js"

import "./ViewPatientReports.vue?vue&type=style&index=0&id=78520b3e&lang=scss&scoped=true"
import "./ViewPatientReports.vue?vue&type=style&index=1&id=78520b3e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78520b3e"]])

export default __exports__